import { FuseNavigationItem } from "@fuse/components/navigation";
import { RoleUtils } from "app/core/auth/roles.utils";

export const adminNavigation: FuseNavigationItem[] = [
  {
    id: 'home',
    title: 'Home',
    type: 'spacer',
    children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'admindashboards',
    title: 'Dashboards',
    type: 'group',
    hidden: () => {
      const hideRoles = [
        'Offshore Personnel',
      ]

      return RoleUtils.currentRoles.some(role => hideRoles.includes(role));
    },
    // icon: 'heroicons_outline:rectangle-group',
    children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'datamanagement',
    title: 'Data Management / Workflow',
    type: 'group',
    icon: 'heroicons_outline:server-stack',
    children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'configurations',
    title: 'Configurations',
    type: 'group',
    icon: 'heroicons_outline:cog',
    hidden: () => {
      const hideRoles = [
        'Offshore Personnel'
      ]

      return RoleUtils.currentRoles.some(role => hideRoles.includes(role));
    },
    children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },

  // {
  //   id: 'business-process',
  //   title: 'Business Process',
  //   type: 'group',
  //   icon: 'heroicons_outline:folder-open',
  //   children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  // },
  // {
  //   id: 'report-and-analytics',
  //   title: 'Report & Analytics',
  //   type: 'group',
  //   icon: 'heroicons_outline:presentation-chart-bar',
  //   children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  // },
  {
    id: 'space-route',
    title: 'Space Route',
    type: 'spacer',
    children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  }
];